module.exports = __webpack_public_path__ + "static/img/m8.b96cc93.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/m8.png
// module id = 8ngU
// module chunks = 0